var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTailArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.803 2.80292C9.0959 2.51003 9.57077 2.51003 9.86366 2.80292L14.5303 7.46959C14.8232 7.76248 14.8232 8.23736 14.5303 8.53025L9.86366 13.1969C9.57077 13.4898 9.0959 13.4898 8.803 13.1969C8.51011 12.904 8.51011 12.4291 8.803 12.1363L12.1893 8.74992H2C1.58579 8.74992 1.25 8.41413 1.25 7.99992C1.25 7.58571 1.58579 7.24992 2 7.24992H12.1893L8.803 3.86358C8.51011 3.57069 8.51011 3.09582 8.803 2.80292Z",
    fill: "#1A73E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailArrow);
export default __webpack_public_path__ + "static/media/Tail-arrow.8dea38c69f21291b913d0f5435bdccc8.svg";
export { ForwardRef as ReactComponent };